import { Navigate, useLocation } from 'react-router-dom';
import { useStytchMemberSession } from '@stytch/react/b2b';

/**
 * ProtectedRoute — envuelve cualquier subárbol que requiera sesión
 * Stytch válida. Si no la hay, redirige a /login guardando la URL
 * de retorno.
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, fromCache } = useStytchMemberSession();
  const location = useLocation();

  // El SDK puede tardar un tick en hidratar la sesión persistida; sin esto
  // el primer render redirigiría a /login aunque haya sesión válida.
  if (fromCache && session === null) {
    return null;
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
